function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_i_29_29)"
}, React.createElement("path", {
  d: "M3.10504 6C3.10504 4.34315 4.44819 3 6.10504 3H36.167C37.8238 3 39.167 4.34315 39.167 6V28.6023C39.167 29.6409 38.6298 30.6056 37.7469 31.1525L22.716 40.4646C21.748 41.0642 20.524 41.0642 19.5561 40.4646L4.5251 31.1525C3.64222 30.6056 3.10504 29.6409 3.10504 28.6023V6Z",
  fill: "url(#paint0_radial_29_29)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter1_d_29_29)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9238 10.2139L12.9239 22.6196L17.8739 22.5902V18.3173H21.7312L25.0343 22.5864H29.7859L26.3579 18.1561C28.9875 17.6036 29.9818 15.7862 29.9818 14.2327C29.9818 12.3188 29.2168 10.2139 24.2561 10.2139L12.9238 10.2139ZM17.8585 12.9876H23.9541C23.9541 12.9876 25.1568 12.9876 25.1568 14.171C25.1568 15.3544 23.9541 15.4473 23.9541 15.4473H17.8585V12.9876Z",
  fill: "white"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter2_d_29_29)"
}, React.createElement("path", {
  d: "M14.0933 27.8242C14.0848 27.7177 14.0448 27.6346 13.9735 27.5749C13.9031 27.5153 13.7961 27.4854 13.6523 27.4854C13.5606 27.4854 13.4855 27.4966 13.4269 27.519C13.3694 27.5403 13.3268 27.5696 13.2991 27.6069C13.2714 27.6442 13.257 27.6868 13.2559 27.7347C13.2538 27.7741 13.2607 27.8098 13.2767 27.8418C13.2938 27.8727 13.3204 27.9009 13.3566 27.9265C13.3928 27.951 13.4392 27.9734 13.4956 27.9936C13.5521 28.0138 13.6192 28.032 13.697 28.0479L13.9655 28.1055C14.1466 28.1438 14.3016 28.1944 14.4305 28.2573C14.5594 28.3201 14.6649 28.3942 14.7469 28.4794C14.8289 28.5636 14.8891 28.6584 14.9275 28.7638C14.9669 28.8693 14.9871 28.9844 14.9882 29.109C14.9871 29.3242 14.9333 29.5064 14.8268 29.6555C14.7203 29.8047 14.5679 29.9181 14.3698 29.9959C14.1727 30.0737 13.9356 30.1126 13.6586 30.1126C13.3742 30.1126 13.126 30.0705 12.914 29.9863C12.703 29.9022 12.539 29.7727 12.4218 29.598C12.3057 29.4222 12.2471 29.1974 12.246 28.9237H13.0898C13.0951 29.0238 13.1201 29.108 13.1649 29.1761C13.2096 29.2443 13.2725 29.296 13.3534 29.3311C13.4355 29.3663 13.5329 29.3839 13.6459 29.3839C13.7407 29.3839 13.82 29.3722 13.884 29.3487C13.9479 29.3253 13.9964 29.2928 14.0294 29.2512C14.0624 29.2097 14.0795 29.1623 14.0805 29.109C14.0795 29.0589 14.0629 29.0153 14.031 28.978C14.0001 28.9396 13.949 28.9055 13.8776 28.8757C13.8062 28.8448 13.7098 28.8161 13.5883 28.7894L13.2623 28.7191C12.9726 28.6562 12.7441 28.5513 12.5768 28.4043C12.4106 28.2562 12.328 28.0543 12.3291 27.7987C12.328 27.5909 12.3834 27.4093 12.4953 27.2537C12.6082 27.0971 12.7643 26.9751 12.9635 26.8878C13.1638 26.8004 13.3934 26.7567 13.6523 26.7567C13.9165 26.7567 14.145 26.801 14.3378 26.8894C14.5306 26.9778 14.6792 27.1025 14.7836 27.2633C14.8891 27.4231 14.9424 27.6101 14.9434 27.8242H14.0933ZM16.6647 26.8015V30.0742H15.7762V26.8015H16.6647ZM17.5357 30.0742V26.8015H18.4242V29.3583H19.7474V30.0742H17.5357ZM21.0691 26.8015L21.7403 29.109H21.7658L22.437 26.8015H23.4406L22.3603 30.0742H21.1458L20.0656 26.8015H21.0691ZM24.2058 30.0742V26.8015H26.5644V27.5174H25.0943V28.0799H26.443V28.7958H25.0943V29.3583H26.558V30.0742H24.2058ZM27.4551 30.0742V26.8015H28.8677C29.1106 26.8015 29.3232 26.8457 29.5053 26.9341C29.6875 27.0225 29.8292 27.1499 29.9304 27.3161C30.0316 27.4822 30.0822 27.6815 30.0822 27.9137C30.0822 28.1481 30.03 28.3457 29.9256 28.5066C29.8223 28.6674 29.6768 28.7889 29.4893 28.8709C29.3029 28.9529 29.085 28.994 28.8358 28.994H27.992V28.3036H28.6568C28.7612 28.3036 28.8501 28.2908 28.9237 28.2653C28.9982 28.2386 29.0552 28.1966 29.0946 28.139C29.1351 28.0815 29.1554 28.0064 29.1554 27.9137C29.1554 27.82 29.1351 27.7438 29.0946 27.6852C29.0552 27.6255 28.9982 27.5819 28.9237 27.5542C28.8501 27.5254 28.7612 27.511 28.6568 27.511H28.3436V30.0742H27.4551ZM29.3727 28.5721L30.1909 30.0742H29.2257L28.4267 28.5721H29.3727Z",
  fill: "white"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_i_29_29",
  x: 3.10504,
  y: 3,
  width: 36.062,
  height: 37.9143,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
  stdDeviation: 6.10322
}), React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.23559 0 0 0 0 0.238151 0 0 0 0 0.245833 0 0 0 1 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_29_29"
})), React.createElement("filter", {
  id: "filter1_d_29_29",
  x: 11.4654,
  y: 10.2139,
  width: 19.9749,
  height: 15.3227,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dy: 1.45847
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.729234
}), React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_29_29"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_29_29",
  result: "shape"
})), React.createElement("filter", {
  id: "filter2_d_29_29",
  x: 8.84501,
  y: 23.3558,
  width: 24.7469,
  height: 10.1578,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
  stdDeviation: 1.70049
}), React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.293576 0 0 0 0 0.318498 0 0 0 0 0.370833 0 0 0 1 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_29_29"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_29_29",
  result: "shape"
})), React.createElement("radialGradient", {
  id: "paint0_radial_29_29",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.136 23.0722) rotate(90) scale(31.2663 29.6765)"
}, React.createElement("stop", {
  stopColor: "#8692AA",
  stopOpacity: 0.95
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#757582"
})));

var SvgSilverNoBorder = function SvgSilverNoBorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSilverNoBorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/silver_no_border.c14f6d16.svg";
export { ForwardRef as ReactComponent };